import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../models/Redeem';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import * as Globals from '../globals';
const url = Globals.serviceUrl;

@Component({
  selector: 'app-redemption',
  templateUrl: './redemption.component.html',
  styleUrls: ['./redemption.component.css']
})
export class RedemptionComponent implements OnInit {

  idtyNo: string;
  invId: number;
  redeems: REDEEM_INVESTOR[];
  tab: number = 1;
  param: any;
  search: string = '';
  loading: boolean;
  seriesId: number;
  totRedeem: number = 0;
  paramSeries: any = { OPEN: false };
  urlFile = Globals.archiveUrl + 'bids?code=';
  series: any[];
  p: number = 1;
  userProfile: any;
  authMenu: any;
  colSort: string[] = ['BID_DATE'];
  reverse: boolean = true;
  col: number = 5;
  rptType: number = 1;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/pemesanan/redemption/0') {
          this.tab = 1;
          this.router.navigate(['/pemesanan/redemption/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/pemesanan/redemption/1']);
    }
    this.redeems = [];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(202, this.userProfile);
    }
  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['IDTY_NO'];
        break;
      case 2:
        this.colSort = ['INV_NAME'];
        break;
      case 3:
        this.colSort = ['REDEMP_ID'];
        break;
      case 4:
        this.colSort = ['ALT_AMT'];
        break;
      case 5:
        this.colSort = ['BID_DATE'];
        break;
      case 6:
        this.colSort = ['REDEEM_AMT'];
        break;
      case 7:
        this.colSort = ['SELLING_AGENT'];
        break;
      default:
        break;
    }
  }
  seriesChanged(ev: any) {
    this.seriesId = ev.target.value;
    this.getRedeems();
    for (var i = 0; i < this.series.length; i++) {
      if (this.seriesId == this.series[i].SERIES_ID) {
        this.paramSeries = this.series[i];
        break;
      }
    }
    /*if (!this.paramSeries.OPEN) {
      this.toastr.warning("Masa penawaran telah berakhir");
    }*/
  }
  getRedeems() {
    this.loading = true;
    this.http.get(url + 'ritel/redeems?seriesId=' + this.seriesId + '&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.redeems = res.json();
        this.totRedeem = 0;
        for (var i = 0; i < this.redeems.length; i++) {
          this.totRedeem += this.redeems[i].REDEEM_AMT;
        }
        /*if (!this.paramSeries.OPEN) {
          this.toastr.warning('Masa penawaran telah berakhir');
        }*/
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSeries() {
    this.loading = true;
    this.http.get(url + 'ritel/redeemactive?cdOnline=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        console.log(this.series);
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          this.getRedeems();
        } else if (this.series.length == 0) {
          //this.toastr.warning('Masa penawaran telah berakhir');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  generateReport(format: string) {

    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",rpttype:' + this.rptType + '}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'Rpt901?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }
  downloadCSV() {
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'ExportCSV?id=' + this.param.TICKET_ID, '_blank');
      }, err => {
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/redemption/redemption.component.ts